import { Component, OnInit } from '@angular/core';
import {AlertService} from "./alert.service";
import {Alert} from "./Alert";

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  open = false;
  message = '';
  type = 'warning';

  constructor(private alertService: AlertService) {
    alertService.alertEvent.subscribe((alert: Alert) => this.show(alert))
  }

  ngOnInit() {
  }

  show(alert: Alert) {

    this.message = alert.message;
    this.type = alert.type;

    this.showAlert();

    if (alert.autoHide) {
      setTimeout(() => {
        this.closeAlert()
      }, alert.autoHideTime);
    }
  }

  showAlert() {
    this.open = true;
  }

  closeAlert() {
    this.open = false;
  }

  isVisible() {
    return this.open;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/alert/alert.component.ts